import React from "react";

import { faTimes } from "@awesome.me/kit-4c83d50d0d/icons/classic/regular";

import IconButton from "~/ui/legacy/IconButton";

import styles from "./TextChip.module.css";

interface TextChipProps {
	text: string;
	onDelete: (text: string) => void;
	disabled?: boolean;
}

function TextChip({ text, onDelete, disabled }: TextChipProps) {
	const onDeleteClick = React.useCallback(() => onDelete(text), [onDelete, text]);

	return (
		<div className={styles.chip}>
			{text} {!disabled && <IconButton icon={faTimes} onClick={onDeleteClick} className={styles.deleteButton} />}
		</div>
	);
}

export default TextChip;
